(function () {
  // split hero title into letters for staggered reveal (homepage only)
  var title = document.getElementById('heroTitle');
  if (title) {
    var words = title.querySelectorAll('.word');
    words.forEach(function (word, w) {
      var chars = word.textContent.trim().split('');
      word.textContent = '';
      chars.forEach(function (c, i) {
        var s = document.createElement('span');
        s.className = c === ' ' ? 'ch sp' : 'ch';
        s.innerHTML = c === ' ' ? '&nbsp;' : c;
        s.style.transitionDelay = (0.25 + w * 0.35 + i * 0.045) + 's';
        word.appendChild(s);
      });
    });
  }

  // intro veil (only rendered on homepage); other pages load instantly
  var veil = document.getElementById('veilTop');
  if (veil) {
    window.addEventListener('load', function () {
      setTimeout(function () { document.body.classList.add('loaded'); }, 1500);
    });
    // fallback in case load already fired
    setTimeout(function () { document.body.classList.add('loaded'); }, 2600);
  } else {
    document.body.classList.add('loaded');
  }

  // nav scrolled state
  var nav = document.querySelector('nav.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // scroll reveals
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
})();
